import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
type CensusPaginationProps = {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
};

/** Builds a compact page list like 1 … 4 5 6 … 20 */
function pageList(page: number, total: number): (number | 'gap')[] {
  if (total <= 7) return Array.from({
    length: total
  }, (_, i) => i + 1);
  const pages = new Set([1, total, page - 1, page, page + 1]);
  const sorted = [...pages].filter(p => p >= 1 && p <= total).sort((a, b) => a - b);
  const out: (number | 'gap')[] = [];
  sorted.forEach((p, i) => {
    if (i > 0 && p - sorted[i - 1] > 1) out.push('gap');
    out.push(p);
  });
  return out;
}
const arrowClass = 'flex h-10 w-10 items-center justify-center rounded-lg border border-primary/15 bg-white text-primary transition hover:border-primary disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-primary/15';
export function CensusPagination({
  page,
  totalPages,
  onChange
}: CensusPaginationProps) {
  if (totalPages <= 1) return null;
  return <nav aria-label="Paginación del censo" className="flex items-center gap-1.5" data-id="element-125" data-mp="37m59a5n9ocsc">
      <button type="button" onClick={() => onChange(page - 1)} disabled={page === 1} aria-label="Página anterior" className={arrowClass} data-id="element-126" data-mp="32od8em4n9gc0">
        <ChevronLeftIcon className="h-4 w-4" data-id="element-127" data-mp="3ckzs37l8i1cg" />
      </button>
      <ul className="hidden items-center gap-1.5 sm:flex" data-id="element-128" data-mp="3cjezhnihcsh8">
        {pageList(page, totalPages).map((p, i) => p === 'gap' ? <li key={`gap-${i}`} aria-hidden className="px-1 text-sm text-foreground/40" data-id="element-129" data-mp="3llo6i3eji3pv">
              …
            </li> : <li key={p} data-id="element-130" data-mp="4451aqhpo7eq">
              <button type="button" onClick={() => onChange(p)} aria-current={p === page ? 'page' : undefined} className={`h-10 min-w-[2.5rem] rounded-lg px-3 text-sm font-bold tabular-nums transition ${p === page ? 'bg-primary text-white' : 'text-primary hover:bg-primary/5'}`} data-id="element-131" data-mp="44dd0f23l6oc">
                {p}
              </button>
            </li>)}
      </ul>
      <span className="px-2 text-sm font-semibold tabular-nums text-foreground/70 sm:hidden" data-id="element-132" data-mp="36ymd3n7abgjb">
        {page} / {totalPages}
      </span>
      <button type="button" onClick={() => onChange(page + 1)} disabled={page === totalPages} aria-label="Página siguiente" className={arrowClass} data-id="element-133" data-mp="3axlbeoyigf1s">
        <ChevronRightIcon className="h-4 w-4" data-id="element-134" data-mp="3krlphgbrsumn" />
      </button>
    </nav>;
}